import { MainCard } from '@components/BaseStyles';
import { Typography, Divider, Skeleton } from '@mui/material';
import { styled } from '@mui/system';

const TitleContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '8px 16px',
  [theme.breakpoints.down(450)]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
}));

const BorderedContainerTitle = styled(Typography)({
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '0.16px',
});

const BorderedContainerRightTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '21px',
  letterSpacing: '0.16px',
  color: theme.palette.text.secondary,
}));

interface BorderedContainerProps {
  title?: string;
  rightTitle?: React.ReactNode;
  children?: React.ReactNode;
  loading?: boolean;
  rounded?: boolean;
}

export const BorderedContainer = ({
  title,
  rightTitle,
  children,
  loading,
  rounded = true,
}: BorderedContainerProps) => {
  if (loading) {
    return (
      <MainCard rounded={rounded}>
        <TitleContainer>
          <Skeleton variant="rectangular" width="140px" height="24px" />
        </TitleContainer>
        <Divider />
        {children}
      </MainCard>
    );
  }
  return (
    <MainCard rounded={rounded}>
      {title && (
        <>
          <TitleContainer>
            <BorderedContainerTitle>{title}</BorderedContainerTitle>
            {rightTitle && (
              <BorderedContainerRightTitle>
                {rightTitle}
              </BorderedContainerRightTitle>
            )}
          </TitleContainer>
          <Divider />
        </>
      )}
      {children}
    </MainCard>
  );
};

export const ContentContainer = styled('div')({
  padding: '8px 16px',
});
